import { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Container, Card, Spinner, Button, Alert } from "react-bootstrap";
import axios from "axios";

export default function Verify() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("loading");
  const hasVerified = useRef(false); // 👈 guard

  useEffect(() => {
    if (hasVerified.current) return;
    hasVerified.current = true;

    const verify = async () => {
      try {
        await axios.get(`/api/auth/verify/${token}`);
        setStatus("success");
      } catch {
        setStatus("error");
      }
    };

    verify();
  }, [token]);

  return (
    <Container 
      style={{ minHeight: "80vh" }}
      className="d-flex justify-content-center align-items-center py-5"
    >
      <Card className="brutal-card text-center" style={{ width: 450, maxWidth: "100%" }}>
        <Card.Body className="p-4 p-md-5">
          {status === "loading" && (
            <>
              <Spinner animation="border" className="mb-4" />
              <p className="brutal-text">VERIFYING YOUR EMAIL…</p>
            </>
          )}

          {status === "success" && (
            <>
              <h2 className="brutal-heading mb-4" style={{ fontSize: "36px" }}>
                EMAIL VERIFIED ✅
              </h2>
              <p className="brutal-text mb-4">YOU CAN NOW LOG IN.</p>
              <Button 
                onClick={() => navigate("/login")} 
                className="brutal-btn brutal-btn-primary w-100"
              >
                GO TO LOGIN
              </Button>
            </>
          )}

          {status === "error" && (
            <>
              <h2 className="brutal-heading mb-4" style={{ fontSize: "36px" }}>
                VERIFICATION FAILED ❌
              </h2>
              <Alert variant="danger" className="brutal-alert mb-4">
                THE LINK IS INVALID OR EXPIRED.
              </Alert>
              <Button 
                onClick={() => navigate("/login")} 
                className="brutal-btn brutal-btn-secondary w-100"
              >
                GO TO LOGIN
              </Button>
            </>
          )}
        </Card.Body>
      </Card>
    </Container>
  );
}
